import { EventType } from 'constants/enums'
import { ComponentBase } from 'utils/abstract-classes/component-base'
import { CompareEventType } from './car-comparison/constants'
import { CarComparisonStore } from './store'
import { TrimSelectorBase } from './trim-selector/trim-selector-base'

/**
 * Model Card Component 🚘
 */
export abstract class AbstractCard extends ComponentBase {
    public year: number
    public make: string
    public model: string
    public vehicleCardID: string

    public addToMyPicksButton: HTMLButtonElement
    public removeResultCardButton: HTMLButtonElement
    public buttonEditMyPicks: HTMLButtonElement
    public removeButton: HTMLButtonElement
    public compareNowButton: HTMLElement
    public makeName: HTMLElement
    public modelName: HTMLElement

    protected openTrimSelectorButton: HTMLButtonElement

    protected get openTrimSelectorButtonClass(): string {
        return ''
    }

    protected get makeNameClass(): string {
        return ''
    }

    protected get modelNameClass(): string {
        return ''
    }

    protected get yearAttr(): string {
        return ''
    }

    protected get makeAttr(): string {
        return ''
    }

    protected get modelAttr(): string {
        return ''
    }

    // get trim trimselector from child cards
    // Ex. ModelCard, VehicleCard
    abstract get trimSelector(): TrimSelectorBase

    public constructor(public wrapper: HTMLElement) {
        super()

        if (!this.bindDataAttributes()) {
            return
        }

        if (!this.bindHTMLElements()) {
            return
        }

        this.bindListeners()
        this.setCardState()
    }

    /**
     * Bind data attributes for find compare page
     * @returns {boolean} indicate if the information exists
     */
    protected bindDataAttributes(): boolean {
        const year = this.wrapper.getAttribute(this.yearAttr)
        const make = this.wrapper.getAttribute(this.makeAttr)
        const model = this.wrapper.getAttribute(this.modelAttr)

        if (!year || !make || !model) {
            return false
        }

        this.year = parseInt(year)
        this.make = make
        this.model = model
        return true
    }

    /**
     * Bind HTML Element for find compare page
     * @returns {boolean} Indicate if the HTML structure is on the screen
     */
    protected bindHTMLElements(): boolean {
        const openTrimSelectorButton = this.getElement<HTMLButtonElement>(
            this.openTrimSelectorButtonClass,
            this.wrapper
        )

        const makeName = this.getElement<HTMLElement>(
            this.makeNameClass,
            this.wrapper
        )

        const modelName = this.getElement<HTMLElement>(
            this.modelNameClass,
            this.wrapper
        )

        if (!openTrimSelectorButton || !makeName || !modelName) {
            return false
        }

        this.openTrimSelectorButton = openTrimSelectorButton
        this.makeName = makeName
        this.modelName = modelName

        return true
    }

    /**
     * Bind event listeners
     */
    protected bindListeners(): void {
        this.openTrimSelectorButton.addEventListener(EventType.CLICK, () => {
            this.openTrimSelector()
        })

        // Success :)
        document.addEventListener(
            CompareEventType.DRIVING_COMPARE_ADD_SUCCESS,
            () => {
                this.setCardState()
            }
        )
        // Failed :(
        document.addEventListener(
            CompareEventType.DRIVING_COMPARE_ADD_FAILED,
            () => {
                this.setCardState()
            }
        )
    }

    /**
     * Set the state comparing with store (already added/ compare for find compare page)
     */
    abstract setCardState(): void

    protected openTrimSelector(): void {
        CarComparisonStore.getInstance().saveLastActiveCard(this)
        void this.trimSelector.openTrimSelector(this)
    }
}
